import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WizumenTripPlanner } from '../../wizumen-models';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { animate, style, transition, trigger } from "@angular/animations";
import { Device } from 'projects/common/model/Device';

@Component({
  selector: 'wizumen-trip-planner',
  template: `
    <div class="wizumen-trip-planner-container">

      <div *ngIf="wizumenTripPlanner.trip_planner">
        <user-landings-card-v2 *ngIf="wizumenTripPlanner.trip_planner" @fade [data]="wizumenTripPlanner.trip_planner!" [moduleIndex]="moduleIndex" [moduleId]="moduleId" [uniqueId]="uniqueId" [upaData]="{}" [device]="device" [typeView]="'horizontal'"
        [showMenu]="false" [showDates]="true" [showFavorites]="true" [showStayDays]="false" [hidePurchase]="true" [sizeImage]="sizeImage"></user-landings-card-v2>
      </div>

      <div *ngIf="!wizumenTripPlanner.trip_planner && wizumenTripPlanner.link" class="trip-planner-create-container">
        <img
          [src]="tripPlannerCreateImageURL"
          alt="trip-planner-image" loading="lazy"/>
        <div class="trip-planner-create-content">
          <p class="trip-planner-create-title">{{wizumenTripPlanner.title}}</p>
          <button *ngIf="!wizumenTripPlanner.trip_planner && wizumenTripPlanner.link?.url && wizumenTripPlanner.link?.title"
            class="wizumen-footer-button eva-3-btn-ghost -md wizumen-spacing" style="margin-top: 8px"
            name="" (click)="handleTripPlannerClick()">
            <em class="btn-text wizumen-footer-link-text">
              {{wizumenTripPlanner.link.title}}
            </em>
          </button>
        </div>
      </div>
    </div>
  `,
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0 }))
      ])
    ]),
  ],
  styleUrls: ['./wizumen-trip-planner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenTripPlannerComponent {

  @Input() wizumenTripPlanner: WizumenTripPlanner;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() device: Device;

  @Input() sizeImage: string;

  tripPlannerCreateImageMediaKey: string = "87229b69-c3f2-4ae9-8015-bbc6ccecea76";
  tripPlannerCreateImageURL: string = "";

  constructor(private mediaPictureService: MediaPictureService, private upaService: UpaService) {
    this.tripPlannerCreateImageURL = this.tripPlannerCreateImageURL = this.mediaPictureService.getMediaUrl(this.tripPlannerCreateImageMediaKey, "48x48")!;
  }

  handleTripPlannerClick() {
    this.trackCreateTripPlannerClick();
    window.open(this.wizumenTripPlanner.link?.url, '_blank');
  }

  trackCreateTripPlannerClick() {
    this.upaService.trackClickTopic({
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      uniqueId: this.uniqueId,
      target: UpaTarget.WIZUMEN_TRIP_PLANNER,
      label: 'wizumen-trip-planner-create',
      href: this.wizumenTripPlanner.link?.url
    })
  }

}
